import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    dropdownParent: { type: String, default: 'body' },
    modal: { type: Boolean, default: false }
  }

  connect() {
    const opts = {
      allowEmptyOption: true,
      dropdownParent: this.dropdownParentValue || 'body',
      onChange: () => {
        this.element.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }

    if (this.modalValue) {
      opts.dropdownParent = document.getElementById('patient_edit_dialog')
      opts.onDropdownOpen = (dropdown) => {
        const rect = this.tomSelect.control.getBoundingClientRect()
        dropdown.style.position = 'fixed'
        dropdown.style.top = (rect.bottom + 2) + 'px'
        dropdown.style.left = rect.left + 'px'
        dropdown.style.width = rect.width + 'px'
      }
    }

    this.tomSelect = new TomSelect(this.element, opts)
  }

  disconnect() {
    this.tomSelect?.destroy()
  }
}
